import React from 'react'
import { useIntl } from 'react-intl'
import { Icons } from 'msp-components'
import { ExpandVideoProps } from './ExpandVideo.types'

const ExpandVideo = ({ className = '', handleExpand }: ExpandVideoProps) => {
  const { formatMessage } = useIntl()
  return (
    <button
      aria-label={formatMessage({
        id: 'msp.stage_component.expand',
        defaultMessage: 'Expand'
      })}
      className={`cc-outline-no-offset-white mb-4 flex flex-row items-center p-2 ${className}`}
      onClick={handleExpand}
    >
      <div
        className={
          'font-Roboto text-12 leading-16 tracking-0 pr-3 uppercase text-white'
        }
      >
        {formatMessage({
          id: 'msp.stage_component.expand',
          defaultMessage: 'Expand'
        })}
      </div>
      <div className={'fill-white'}>
        <Icons iconName={'VideoExpand'} height={'25px'} width={'25px'} />
      </div>
    </button>
  )
}

export default ExpandVideo
